// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__KassaCarousel from "./KassaCarousel.js";
import * as Buhta_landing__KassaTiles from "./KassaTiles.js";
import * as Buhta_landing__KassaTilesMobile from "./KassaTilesMobile.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function KassaOutro(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: "Наша касса подходит для всех видов бизнеса",
        className: "h4 lg:h2 text-center text-black-landing lg:flex lg:m-auto lg:mt-30 lg:w-141.25"
      }),
      JsxRuntime.jsx("p", {
        children: "Если ваш бизнес работает с автоматизированными системами, то интегрироваться с нами проще простого. Если у вас пока ручная работа, то мы значительно упростим вашу работу за счет автоматического создания чеков при продажах.",
        className: "paragraph-large lg:h-light text-center lg:flex lg:mx-auto mt-2 lg:w-200 text-black-landing"
      }),
      deviceType === "mobile" || deviceType === "tablet" ? JsxRuntime.jsx(Buhta_landing__KassaTilesMobile.make, {}) : JsxRuntime.jsx(Buhta_landing__KassaTiles.make, {}),
      JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
        classes: {
          hd: "flex m-auto mt-10 lg:mt-16",
          tl: /* [] */ 0
        },
        label: Buhta_landing__I18n.trans(intl, "start_using"),
        onClick: (function (param) {
          Buhta_landing__EventHandlers.scrollToFooter(deviceType);
        })
      }),
      JsxRuntime.jsx("p", {
        children: "Уже пользуются 125 предпринимателей",
        className: Cn.fromList({
          hd: "paragraph-small text-center text-gray-landing mt-4",
          tl: /* [] */ 0
        })
      }),
      JsxRuntime.jsx("h3", {
        children: "Где можно посмотреть как это работает?",
        className: "h4 lg:h2 text-center text-black-landing lg:flex lg:m-auto mt-20 lg:mt-30 lg:w-145"
      }),
      JsxRuntime.jsx(Buhta_landing__KassaCarousel.make, {})
    ],
    className: "pt-20 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = KassaOutro;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
